<template>
  <div>
    <form enctype="multipart/form-data" novalidate>
      <div class="dropbox" :class="{ disabled: percentCompleted > -1 }">
        <template v-if="percentCompleted < 0">
          <input
            ref="fileRef"
            type="file"
            accept="image/png, image/jpeg, video/*"
            class="input-file"
            @change="onFileChange"
          />

          <div v-html="$t('ARTWORK_UPLOAD.INPUT_DESC')"></div>

          <v-alert
            v-if="errors.length"
            :value="true"
            type="error"
            dismissible
            @input="errors = []"
            >{{ errors.join(" ") }}</v-alert
          >
        </template>
        <v-progress-circular
          v-else
          :rotate="360"
          :size="100"
          :width="15"
          :value="percentCompleted"
          >{{ percentCompleted }}</v-progress-circular
        >
      </div>
    </form>
  </div>
</template>

<script>
import { convertToBase64 } from "@/utils/FileHelpers";
import { RepositoryFactory } from "@/services/RepositoryFactory";
import { ProfileArtwork } from "@/services/artwork/ProfileArtwork";

const artworksRepo = RepositoryFactory.artworks();

export default {
  props: {
    artwork: {
      type: ProfileArtwork,
    },
  },

  data() {
    return {
      percentCompleted: -1,
      errors: [],
    };
  },

  methods: {
    async onFileChange(e) {
      this.errors = [];
      const file = e.target.files[0];

      console.log("onFileChange", file, this.artwork);

      if (file && file.type.match("video.*")) {
        if (!this.artwork || !this.artwork.media.length) {
          this.errors = [this.$tc("ARTWORK_UPLOAD.UPLOAD_MAIN_IMAGE_FIRST")];
          return;
        }

        console.log("File is video", this.artwork);
        this.uploadVideo(file);
        return;
      }

      this.percentCompleted = 1;

      const base64 = await convertToBase64(file);
      const config = {
        onUploadProgress: (progressEvent) => {
          const percentage = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          this.percentCompleted = percentage === 100 ? 99 : percentage;
        },
      };

      const payload = {
        image: base64,
      };

      const artworkId = this.artwork ? this.artwork.id : null;

      try {
        const resp = await artworksRepo.createArtwork(
          artworkId,
          1,
          false,
          payload,
          config
        );

        this.$emit("uploaded", resp);
      } catch (error) {
        console.error(error.data.errors);

        if (error.data && error.data.errors && error.data.errors.image) {
          this.errors = error.data.errors.image;
        }

        this.$emit("error");
      }
      this.percentCompleted = -1;
    },

    async uploadVideo(video) {
      this.percentCompleted = 1;

      const config = {
        onUploadProgress: (progressEvent) => {
          const percentage = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          this.percentCompleted = percentage === 100 ? 99 : percentage;
        },
      };

      try {
        const res = await artworksRepo.uploadVideo(
          this.artwork.id,
          { video },
          config
        );

        console.log(res);

        this.$emit("video-uploaded", res.data["data"].video_id);
        
      } catch (error) {
        console.log("Error:", error.data);

        if (error.data && error.data.errors && error.data.errors.video) {
          this.errors = error.data.errors.video;
        }

        this.$emit("error");
      }

      this.percentCompleted = -1;
    },
  },
};
</script>

<style lang="scss" scoped>
.dropbox {
  border: 2px dashed grey; /* the dash box */
  color: dimgray;
  padding: 10px 10px;
  position: relative;
  text-align: center;
  border-radius: 10px;

  &:hover:not(.disabled) {
    background: #eaeaea; /* when mouse over to the drop zone, change color */
  }

  .disabled {
    opacity: 0.5;
  }

  p {
    font-size: 1.2em;
    color: #000;
  }
  p.upload-info {
    font-size: 1rem;
  }
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: absolute;
  border-radius: 10px;

  cursor: pointer;
  &:disabled {
    cursor: default;
  }
}
</style>
